import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { checkStatus } from '../../../../util/util';

class UpdateDriver extends Component {

    constructor(props) {

        super(props);
        
        this.state = {
            prefix:'', 
            first_name:'', 
            last_name:'', 
            gender:'',     
            telephone:'', 
            birthday: null, 
            card_number:'', 
            card_registrar:'', 
            card_nation:'', 
            license_type:'', 
            license_gov:'', 
            license_number:'', 
            license_start:null, 
            license_expire:null, 
            note:'', 
            driver_id:'',
        }
        this.handleChangeBirthday = this.handleChangeBirthday.bind(this);
        this.handleChangeLicenseStart = this.handleChangeLicenseStart.bind(this);
        this.handleChangeLicenseExpire = this.handleChangeLicenseExpire.bind(this);
    }

    

    componentWillMount(){
        
        const {dataUpdate} = this.props;
        this.setState({
            prefix:dataUpdate.prefix, 
            first_name:dataUpdate.first_name, 
            last_name:dataUpdate.last_name, 
            gender:dataUpdate.gender,     
            telephone:dataUpdate.telephone, 
            birthday: dataUpdate.birthday==null?null: this.dateWrapper(moment(dataUpdate.birthday)), 
            card_number:dataUpdate.card_number, 
            card_registrar:dataUpdate.card_registrar, 
            card_nation:dataUpdate.card_nation, 
            license_type:dataUpdate.license_type, 
            license_gov:dataUpdate.license_gov, 
            license_number:dataUpdate.license_number, 
            license_start:dataUpdate.license_start==null?null: this.dateWrapper(moment(dataUpdate.license_start)), 
            license_expire:dataUpdate.license_expire==null?null: this.dateWrapper(moment(dataUpdate.license_expire)), 
            note:dataUpdate.note, 
            driver_id:dataUpdate.driver_id,
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.deviceInfo !== this.props.deviceInfo ) {

            let deviceInfo = nextProps.deviceInfo;
           
        }
    }

    componentDidMount(){
        
    }


    componentWillUnmount(){
       
    }

    

    dateWrapper(rDate){

        let rDateWrapper=rDate;
        if(rDate!=null && rDate.toObject().years>2500){
          rDateWrapper=moment((rDate.toObject().years-543)+'-'+rDate.toObject().months+'-'+rDate.toObject().date);
        }
        return rDateWrapper;
      }
      
      handleChangeBirthday(date) {
        this.setState({
            birthday:date
        });
        
      }

      handleChangeLicenseStart(date) {
        this.setState({
            license_start:date
        });
        
      }
      
      handleChangeLicenseExpire(date) {
        this.setState({
            license_expire:date
        });
        
      }

      handleChangeExpireDate(date) {
        this.setState({
            expire_date: date
        });
      }

      convertMomentToString(moment){
        let date = moment.toObject().date;
        let months = moment.toObject().months;
        let years = moment.toObject().years;

        months = months+1;
        if(date.toString().length == 1){
            date = '0'+date;
        }
        if(months.toString().length == 1){
            months = '0'+months;
        }
        // return date+'-'+months+'-'+years;
        return years+'-'+months+'-'+date;

      }


    onClickSubmit(){
        const { onSubmitEdit } = this.props;
        
        // const { isErrorField } = this.state;
        let data = {};
        let isErrorField = false;
        const {

            prefix, 
            first_name, 
            last_name, 
            gender,     
            telephone, 
            birthday, 
            card_number, 
            card_registrar, 
            card_nation, 
            license_type, 
            license_gov, 
            license_number, 
            license_start, 
            license_expire, 
            note,
            driver_id,
        } = this.state;
        
        if (prefix && prefix.length > 0) {
            data.prefix = prefix.trim();
        }

        if (first_name && first_name.length > 0) {
            data.first_name = first_name.trim()
            isErrorField = false;
        } else {
            isErrorField = true;
        }

        if (last_name && last_name.length > 0) {
            data.last_name = last_name.trim()
        }

        if (telephone && telephone.length > 0) {
            data.telephone = telephone.trim()
        }

        if (card_number && card_number.length > 0) {
            data.card_number = card_number.trim()
        }

        if (card_registrar && card_registrar.length > 0) {
            data.card_registrar = card_registrar.trim()
        }

        if (card_nation && card_nation.length > 0) {
            data.card_nation = card_nation.trim()
        }


        if (license_type && license_type.length > 0) {
            data.license_type = license_type.trim()
        }


        if (license_number && license_number.length > 0) {
            data.license_number = license_number.trim()
        }


        if (license_gov && license_gov.length > 0) {
            data.license_gov = license_gov.trim()
        }


        if (note && note.length > 0) {
            data.note = note.trim()
        }


        if (birthday) {
            let date = this.convertMomentToString(birthday);
            data.birthday = date;
        }

        if (license_start) {
            let date = this.convertMomentToString(license_start);
            data.license_start = date;
        }

        if (license_expire) {
            let date = this.convertMomentToString(license_expire);
            data.license_expire = date;
        }


        if (gender) {
            data.gender = gender;
        }
        
        data.driver_id = driver_id;

        if (!isErrorField) {
            onSubmitEdit(data);
        }else{
            alert("กรุณาระบุชื่อพนักงานขับรถ");
        }
    }

    changeformatDate(date){
        let str = date.split("-");
        return str[2]+' '+str[1]+' '+str[0];
    }

    handleChangeRadio = (e) => {
        this.setState({
            gender:e.target.value
        });
    }

    onClickBack = () => {
        const {onBack} = this.props;
        onBack();
    }

    render(){

        const {} = this.props;
        
        const {
            prefix, 
            first_name, 
            last_name, 
            gender,     
            telephone, 
            birthday, 
            card_number, 
            card_registrar, 
            card_nation, 
            license_type, 
            license_gov, 
            license_number, 
            license_start, 
            license_expire, 
            note,
            driver_id,
        } = this.state;
        return(
        
        
        <div className="container-fluid">
            <div className="card">
                <div className="card-header">
                    <h5 className=""> <i class="fa fa-arrow-left" aria-hidden="true" style={{color: '#7386D5',cursor: 'pointer'}} onClick={this.onClickBack}></i> รายการพนักงานขับรถ</h5>
                    
                </div>
                <div className="card-body">
                    <h6>บันทึกข้อมูลพนักงานขับรถ</h6>
                    <br />
                    <div className="row">
                        <div className="col-md-6">
                            <form>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label ">คำนำหน้า</label>
                                    <div className="col-md-8" >
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.prefix}
                                            onChange={(e) => this.setState({ prefix: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label ">ชื่อ</label>
                                    <div className="col-md-8">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.first_name}
                                            onChange={(e) => this.setState({ first_name: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group   row">
                                    <label className="col-md-4  col-form-label ">นามสกุล</label>
                                    <div className="col-md-8">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.last_name}
                                            onChange={(e) => this.setState({ last_name: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group  row">
                                
                                    <label  className="col-md-4 col-form-label">
                                        <span>
                                        เพศ
                                        </span>
                                    </label>
                                    <label  className="col-md-2 col-form-label text-left">
                                        <input
                                        type="radio"
                                        value='ชาย'
                                        name="gender"
                                        checked={this.state.gender == 'ชาย'}
                                        onChange={this.handleChangeRadio}
                                        />
                                        ชาย
                                    </label>
                                    <label  className="col-md-2 col-form-label text-left">
                                        <input
                                        type="radio"
                                        value='หญิง'
                                        name="gender"
                                        checked={this.state.gender == 'หญิง'}
                                        onChange={this.handleChangeRadio}
                                        />
                                        หญิง
                                    </label>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label ">เบอร์โทร</label>
                                    <div className="col-md-8">
                                        <div className="input-group mb-3">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.telephone}
                                            onChange={(e) => this.setState({ telephone: e.target.value })}
                                        />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label ">วันเกิด</label>
                                    <div className="col-md-8">
                                        <DatePicker className="form-control"
                                            selected={this.state.birthday}
                                            onChange={this.handleChangeBirthday}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label ">หมายเหตุ</label>
                                    <div className="col-md-8">
                                        <textarea  
                                            className="form-control"
                                            id="userName"
                                            value={this.state.note}
                                            onChange={(e) => this.setState({ note: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-md-6">
                            <form>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label ">เลขบัตรประชาชน</label>
                                    <div className="col-md-8" >
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.card_number}
                                            onChange={(e) => this.setState({ card_number: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label ">นายทะเบียนประจำ</label>
                                    <div className="col-md-8">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.card_registrar}
                                            onChange={(e) => this.setState({ card_registrar: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group   row">
                                    <label className="col-md-4  col-form-label ">ประเทศ</label>
                                    <div className="col-md-8">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.card_nation}
                                            onChange={(e) => this.setState({ card_nation: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group   row">
                                    <label className="col-md-4  col-form-label ">ประเภทใบขับขี่</label>
                                    <div className="col-md-8">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.license_type}
                                            onChange={(e) => this.setState({ license_type: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group   row">
                                    <label className="col-md-4  col-form-label ">ออกที่สาขา</label>
                                    <div className="col-md-8">
                                        
                                        <div className="input-group mb-3">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.license_gov}
                                            onChange={(e) => this.setState({ license_gov: e.target.value })}
                                        />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group   row">
                                    <label className="col-md-4  col-form-label ">เลขที่</label>
                                    <div className="col-md-8">
                                        
                                        <div className="input-group mb-3">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.license_number}
                                            onChange={(e) => this.setState({ license_number: e.target.value })}
                                        />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label ">วันอนุญาต</label>
                                    <div className="col-md-8">
                                        <DatePicker className="form-control"
                                            selected={this.state.license_start}
                                            onChange={this.handleChangeLicenseStart}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label ">วันครบกำหนด</label>
                                    <div className="col-md-8">
                                        <DatePicker className="form-control"
                                            selected={this.state.license_expire}
                                            onChange={this.handleChangeLicenseExpire}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <hr/>
                        <div className="text-right">
                            <input type="button" className="btn btn-primary" onClick={() => {this.onClickSubmit()}} value="บันทึกข้อมูล" />
                            {/* &nbsp;&nbsp;&nbsp;
                            <input type="button" className="btn btn-danger"  value="ลบข้อมูล" /> */}
                        </div>
                </div>
             </div>    
        </div>
            
        );
    }
}
UpdateDriver.defaultProps = {
    dataUpdate:{}
}

UpdateDriver.propTypes = {
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    onSubmitEdit:PropTypes.func.isRequired,
    onBack:PropTypes.func,
    dataUpdate:PropTypes.object,
}
export default UpdateDriver;


// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/UpdateDriver.js